import { createRequestService, RequestServiceData } from '../../shared/lib/request';

export const createWidgetRequestService = (data: RequestServiceData) => {
  const service = createRequestService({ ...data });

  return service;
};
